import { valueOrArrayToArray, isUndefinedOrNull } from "@daytrip/utils";
import type { SimpleUser } from "@daytrip/legacy-models";
import type { ExportRecord } from "@daytrip/legacy-models";
import type { RetrieveExportRecordsOptions } from "@daytrip/legacy-options";
import { RetrieveSimpleUsersOptions } from "@daytrip/legacy-options";
import { plainToClass } from "class-transformer";
import { action, observable, toJS } from "mobx";

import { PageStore } from "../../stores/PageStore";
import { apiTrpcClient } from "../../trpc/api";

import type { ExportsPageRouter } from "./ExportsPageRouter";

export class ExportsPageStore extends PageStore<ExportsPageRouter, null> {
    @observable
    public exportRecords?: Array<ExportRecord>;

    @observable
    public exportRecordsCount: number = 0;

    @observable
    public users?: Array<SimpleUser>;

    @action
    public async onFetchData() {
        await this.fetchContent();
    }

    @observable
    public authenticationToken?: string;

    @action
    public async fetchContent() {
        this.exportRecords = undefined;
        this.authenticationToken = this.authenticationStore.authenticationToken;

        const options = {
            skip: this.pageRouter.skip,
            limit: this.pageRouter.limit,
            sortBy: this.pageRouter.sortBy,
            sortDirection: this.pageRouter.sortDirection,
            search: this.pageRouter.search,
            requesterIds: isUndefinedOrNull(this.pageRouter.requesterIds)
                ? undefined
                : toJS(valueOrArrayToArray(this.pageRouter.requesterIds)),
            exportItem: isUndefinedOrNull(this.pageRouter.exportItem) ? undefined : this.pageRouter.exportItem,
        } as RetrieveExportRecordsOptions;
        this.exportRecords = await apiTrpcClient.export.retrieveExportRecords.query(options);
        this.exportRecordsCount = await apiTrpcClient.export.retrieveExportRecordsCount.query(options);

        const userOptions: RetrieveSimpleUsersOptions = plainToClass(RetrieveSimpleUsersOptions, {
            userIds: this.exportRecords.map((er) => er.requestedBy),
        });
        this.users = await this.rpcClient.user.retrieveSimpleUsers(userOptions);
    }

    public isDataFetched(): this is ExportsPageStore & ExportsPageStoreDataFetched {
        return !!(this.exportRecords && this.users);
    }
}

export interface ExportsPageStoreDataFetched {
    exportRecords: Array<ExportRecord>;
}
